export default __webpack_public_path__ + "static/media/left-nav.69c59d6f.svg";